import { debounce } from '../util';
import { prefixRelativeUrl } from '../util.js';
import 'bootstrap-autocomplete';
(function () {
    const $checklistSearchForm = document.querySelector('form.js-checklist-search-form');
    const $checklistList = document.querySelector('.js-checklist-list');

    if (!$checklistSearchForm || !$checklistList) return;

    function getChecklistSearchQueryParams() {
        var params = [];

        var checklistSearchInput = document.querySelector('#search-checklist-input');

        if (
            checklistSearchInput &&
            checklistSearchInput.value !== '' &&
            checklistSearchInput.value != null
        ) {
            params.push(`query=${checklistSearchInput.value}`);
        }

        // Check industryfacets
        // delimiter ¤
        var checkedIndustryFacets = [];
        document
            .querySelectorAll(
                '.multiple-select-input[data-facet-id="is"] input[type="checkbox"]:checked'
            )
            .forEach((facet) => {
                checkedIndustryFacets.push(facet.value);
            });

        if (checkedIndustryFacets.length > 0) {
            params.push(`is=${checkedIndustryFacets.join('¤')}`);
        }

        // Check subjectfacets
        var checkedSubjectFacets = [];
        document
            .querySelectorAll(
                '.multiple-select-input[data-facet-id="ss"] input[type="checkbox"]:checked'
            )
            .forEach((facet) => {
                checkedSubjectFacets.push(facet.value);
            });

        if (checkedSubjectFacets.length > 0) {
            params.push(`ss=${checkedSubjectFacets.join('¤')}`);
        }

        // Check letterfacet
        var selectedLetter = document.querySelector('input[type="hidden"][name="letter"]');

        if (selectedLetter != null) {
            params.push(`ix=${selectedLetter.value}`);
        }

        return params.join('&');
    }

    function getChecklistHits() {
        var searchUrl = `${document
            .querySelector('form.js-checklist-search-form')
            .getAttribute('action')}?${getChecklistSearchQueryParams()}`;

        $.ajax({
            method: 'get',
            url: `${searchUrl}`,
            cache: false
        }).done((data) => {
            let pageUrl = `${location.protocol}//${location.host}${
                location.pathname
            }?${getChecklistSearchQueryParams()}`;

            window.history.pushState({}, '', pageUrl);

            $checklistList.innerHTML = data;
            if (window.innerWidth > 756) {
                document.querySelector('#search-checklist-input').focus();
            }

            document
                .querySelector('form.js-checklist-search-form')
                .addEventListener('submit', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    getChecklistHits();
                });
        });
    }

    const getChecklistHitsDebounced = debounce(getChecklistHits, 250);

    $('body').on('click', '.multiple-select-input label', (event) => {
        // Wait 50 ms for the checkbox change to occur
        console.log('click event');
        getChecklistHitsDebounced();
    });

    $('body').on('click', '.selected-item-chip.js-remove-specific', (event) => {
        // Wait 50 ms for the checkbox change to occur
        const { referenceName, type } = event.target.dataset;

        if (type === 'ix') {
            $('input[name="letter"]').val('');
        } else if (type === 'queryString') {
            $(`#${referenceName}`).val('');
        } else {
            $(`#${referenceName}`).prop('checked', false);
        }

        getChecklistHitsDebounced();
    });

    $('body').on('click', '.selected-item-chip.js-remove-all', (event) => {
        // Wait 50 ms for the checkbox change to occur
        $('.js-facet-checkbox').prop('checked', false);

        $('input[name="letter"]').val('');

        $('#search-checklist-input').val('');

        getChecklistHitsDebounced();
    });

    $('body').on('keyup', '.multiple-select-input input[type="checkbox"]', (event) => {
        if (event.keyCode === 32 || event.keyCode === 13) {
            // Wait 50 ms for the checkbox change to occur
            event.stopPropagation();

            if (event.keyCode === 13) {
                // Help enter-button to check the box
                event.target.checked = !event.target.checked;
            }

            getChecklistHitsDebounced();
        }
    });
    $('body').on('keydown', 'form.js-checklist-search-form', (event) => {
        if (
            event.keyCode === 13 &&
            event.target.id !== 'search-checklist-input' &&
            !event.target.matches('button[type="button"]')
        ) {
            event.preventDefault();
            event.stopPropagation();
        }
    });
    $('body').on('click', 'button[data-checklist-letter]', (event) => {
        event.currentTarget
            .closest('fieldset[data-multiple-select-input]')
            .querySelector('input[name="letter"]').value = event.currentTarget.dataset.value;
        console.log(
            event.currentTarget
                .closest('fieldset[data-multiple-select-input]')
                .querySelector('input[name="letter"]')
        );
        getChecklistHitsDebounced();
    });

    $('#search-checklist-input').autoComplete({
        minLength: 2,
        noResultsText: 'Inga förslag',
        resolverSettings: {
            queryKey: 'prefix',
            url: prefixRelativeUrl('/find_v2/_autocomplete')
        },
        formatResult: (item) => {
            return {
                value: item.query,
                text: item.query
            };
        },
        events: {
            searchPost: (data, jqElement) => {
                return data.hits;
            }
        }
    });

    if ($checklistSearchForm) {
        $checklistSearchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();

            getChecklistHits();
        });
    }
})();
